function requestData(detailData, useBirthMonthDiscount, walletAmount, couponList, bcShipmentFeeList) {
  // console.log('requestData');
  // console.log(couponList);
  let userDetail = JSON.parse(localStorage.getItem('userDetail'));
  let data = {
    creditCardId: 0,
    deliveryDate: '',
    deliveryAddressId: 0,
    deliveryTimeId: 0,
    paymentCount: 0,
    paymentMethod: null,
    purchaseCouponList: [],
    purchaseOrderList: [],
    useBirthMonthDiscount: useBirthMonthDiscount,
    walletAmount: walletAmount,
  };
  if(couponList != null && couponList != undefined) {
    data.purchaseCouponList.push(...couponList);
  }

  if(detailData != null) {
    if(userDetail) {
      console.log('storage');
      data.creditCardId = userDetail.selectCreditData.creditCardId;
      data.deliveryDate = userDetail.deliveryDate.deliveryDateValue;
      data.deliveryAddressId = userDetail.deliveryAddressData.deliveryAddressId;
      data.deliveryTimeId = userDetail.deliveryTimeData.deliveryTimeId;
      data.paymentMethod = userDetail.paymentData.paymentMethod;
      data.paymentCount = detailData.paymentData.paymentCount;
      // data.purchaseCouponList.push(...userDetail.couponList);
    } else {
      data.creditCardId = detailData.selectCreditData.creditCardId;
      data.deliveryDate = detailData.deliveryDate.deliveryDateValue;
      data.deliveryAddressId = detailData.deliveryAddressData.deliveryAddressId;
      data.deliveryTimeId = detailData.deliveryTimeData.deliveryTimeId;
      data.paymentMethod = detailData.paymentData.paymentMethod;
      data.paymentCount = detailData.paymentData.paymentCount;

      // data.purchaseCouponList.push(...detailData.couponList);
    }
  }

  let orderData = purchaseOrderList(bcShipmentFeeList);
  data.purchaseOrderList.push(...orderData);

  return data;
}

function purchaseOrderList(bcShipmentFeeList) {
  // console.log('purchaseOrderList');
  // console.log(bcShipmentFeeList);
  let orderList = [];
  // purchaseOrderListに入れるデータの作成開始
  let bcList = JSON.parse(localStorage.getItem('selectBC'));

  let date = new Date();
  let currentYear = date.getFullYear();
  let currentMonth = date.getMonth() + 1;

  if(bcList) {
    for (var i = 0; i < bcList.length; i++) {
      let bcItems = JSON.parse(localStorage.getItem(bcList[i]));

      if(bcItems != null && bcItems.length > 0) {
        let orderData = {
          bcNo: bcList[i],
          currentMonth: 0,
          purchaseOrderItemList: [],
          shipmentFee: matchBcShipmentFee(bcList[i], bcShipmentFeeList),
          totalPrice: 0,
        };

        for (var a = 0; a < bcItems.length; a++) {
          orderData.currentMonth = bcItems[a].currentOrderMonth;
          for (var b = 0; b < bcItems[a].countItem.length; b++) {
            if(bcItems[a].countItem[b].count != 0) { // 注文0なら弾く
              let currentMonthBool = false;
              if(b == 0) {
                currentMonthBool = true;
              }
              let itemList = {
                childFund: bcItems[a].child,
                currentMonth: currentMonthBool,
                orderCount: bcItems[a].countItem[b].count,
                orderMonth: bcItems[a].countItem[b].month,
                orderYear: bcItems[a].countItem[b].year,
                productId: bcItems[a].productId,
                genreId: bcItems[a].genreId,
                price: bcItems[a].itemPrice * bcItems[a].countItem[b].count + (bcItems[a].child ? 100 * bcItems[a].countItem[b].count : 0),
              };
              orderData.totalPrice += bcItems[a].price;
              orderData.purchaseOrderItemList.push(itemList);
            }
          }
        }
        // orderData.totalPrice = await calcTotalPrice(orderData);
        orderList.push(orderData);
      }
    }
  }

  return orderList;
}

function calcTotalPrice(data) {
  let totalPrice = 0;
  if(data.length > 0) {
    for (var i = 0; i < data.length; i++) {
      if(data[i].purchaseOrderItemList.length > 0) {
        for (var a = 0; a < data[i].purchaseOrderItemList.length; a++) {
          totalPrice += data[i].purchaseOrderItemList[a].price;
        }
      }
    }
  }

  return totalPrice;
}

function calcDiscountCoupon(userDetailCouponList) {
  // クーポン割引計算
  let discountPrice = 0;
  if(userDetailCouponList.length > 0) {
    for (var i = 0; i < userDetailCouponList.length; i++) {
      discountPrice += userDetailCouponList[i].discountPrice * userDetailCouponList[i].useCount;
    }
  }
  return discountPrice;
}

function matchBcShipmentFee(bc, bcShipmentFeeList) {
  if(bcShipmentFeeList != null && bcShipmentFeeList.length > 0) {
    let matchData =  bcShipmentFeeList.find((val) => { return val.bcNo == bc; });
    return matchData.shipmentFee;
  } else {
    return 0;
  }
}

export default {
  requestData,
  purchaseOrderList,
  calcTotalPrice,
  calcDiscountCoupon
}



// WEBPACK FOOTER //
// ./src/model/purchase/purchaseWallet.js